import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AlgoliaBroker, AlgoliaBrokerage } from '@fnModels/algolia/broker';
import { MortgageBroker } from '@models/brokerage';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select } from '@ngxs/store';
import {
	MortgageBrokerSearchDispatch,
	MortgageBrokerSearchState,
} from '@state/algolia-search/mortgage-broker-search';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DropdownResult } from 'src/app/shared/atomic/atoms/dropdown-options/dropdown-options.component';
import { ICON } from '@core/util/icon';

export enum DropdownSelect {
	SELECT_MORTGAGE_BROKERAGE = 'SELECT_MORTGAGE_BROKERAGE',
	SELECT_MORTGAGE_BROKER = 'SELECT_MORTGAGE_BROKER',
}

@UntilDestroy()
@Component({
	selector: 'app-search-mortgage-broker-input',
	templateUrl: './search-mortgage-broker.component.html',
	standalone: false,
})
export class SearchMortgageBrokerComponent implements OnInit {
	public dropdownOptions = DropdownSelect;
	public _brokers: MortgageBroker[];
	public loading = false;
	public selected;
	public ICON = ICON;
	public searchTerm: string;

	@Select(MortgageBrokerSearchState.getList) mortgageBrokers$: Observable<
		MortgageBroker[]
	>;
	@Select(MortgageBrokerSearchState.getSearching)
	searchingMortgageBrokers$: Observable<boolean>;

	@Output() onSelectedBroker = new EventEmitter<AlgoliaBroker>();
	@Output() onCreateBroker = new EventEmitter<string>();
	@Output() onRemoveBroker = new EventEmitter();

	ngOnInit(): void {
		combineLatest([this.mortgageBrokers$])
			.pipe(
				untilDestroyed(this),
				map(([brokers]) => {
					this.loading = false;
					this._brokers = brokers;
				}),
			)
			.subscribe();
	}

	constructor(
		private mortgageBrokerSearchDispatch: MortgageBrokerSearchDispatch,
	) {}

	search = ($event) => {
		this.loading = true;
		this.mortgageBrokerSearchDispatch.search($event);
		this.searchTerm = $event;
	};

	onSelect = (ev: DropdownResult<AlgoliaBroker | AlgoliaBrokerage>) => {
		if (ev.groupType === DropdownSelect.SELECT_MORTGAGE_BROKER) {
			const result = ev.result as AlgoliaBroker;
			this.onSelectedBroker.emit(result);
		}
	};

	createBroker() {
		this.onCreateBroker.emit(this.searchTerm);
	}
}
